import { AxiosResponse } from 'axios'
import { generalServiceAPI } from '@/store/api-instance'
import { IOrderStatus } from '../interface/IOrderStatus'

async function getOrderStatusAPI () {
  const response: AxiosResponse = await generalServiceAPI.get<IOrderStatus>('orders/GetListOrderStatus')
  return response?.data
}

export {
  getOrderStatusAPI
}
